import { Dashboard, Http } from '../../../models/index';
import { SaveAttributesResource } from './SaveAttributesResource';

export class SaveDashboard extends SaveAttributesResource<Dashboard> {
    /* istanbul ignore next */
    constructor(http: Http) {
        super(http);
    }
}
